import { useState, useEffect, useRef } from 'react';

/**
 * Soft builder phase by selection count only (no hard Base requirement).
 */
export function useBuilderPhase(selectedIngredients) {
  const builderPhaseIndex =
    selectedIngredients.length === 0
      ? 0
      : selectedIngredients.length < 2
        ? 1
        : 2;

  const prevPhaseRef = useRef(null);
  const [builderPhaseAnim, setBuilderPhaseAnim] = useState(false);

  useEffect(() => {
    if (prevPhaseRef.current === null) {
      prevPhaseRef.current = builderPhaseIndex;
      return undefined;
    }
    if (prevPhaseRef.current !== builderPhaseIndex) {
      prevPhaseRef.current = builderPhaseIndex;
      setBuilderPhaseAnim(true);
      const t = window.setTimeout(() => setBuilderPhaseAnim(false), 320);
      return () => window.clearTimeout(t);
    }
    return undefined;
  }, [builderPhaseIndex]);

  return { builderPhaseIndex, builderPhaseAnim };
}
